import { Button } from '@repo/ui/components/ui/button'
import { createFileRoute, Link, useRouter } from '@tanstack/react-router'
import { Shield, Wallet } from 'lucide-react'
import { WorkspaceRouteShell } from '@/components/app/route-shells'
import { AppTopBarActionGroup, AppTopBarActions } from '@/components/app/top-bar-actions'
import { SettingsWorkspace } from '@/components/settings/settings-dialog'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/settings')({
  component: AccountPage,
  staticData: {
    breadcrumbs: [{ label: 'Settings', href: '/settings' }],
  } satisfies RouteStaticData,
})

function AccountPage() {
  const router = useRouter()

  return (
    <WorkspaceRouteShell>
      <AppTopBarActions>
        <AppTopBarActionGroup>
          <Button asChild variant="outline" size="sm">
            <Link to="/billing">
              <Wallet className="h-4 w-4" />
              Billing
            </Link>
          </Button>
          <Button asChild size="sm">
            <Link to="/">
              <Shield className="h-4 w-4" />
              Back to operations
            </Link>
          </Button>
        </AppTopBarActionGroup>
      </AppTopBarActions>
      <SettingsWorkspace
        defaultTab="general"
        onSignedOut={() => {
          router.navigate({ to: '/auth/$authView', params: { authView: 'sign-in' } })
        }}
        onAccountDeleted={() => {
          router.navigate({ to: '/auth/$authView', params: { authView: 'sign-in' } })
        }}
      />
    </WorkspaceRouteShell>
  )
}
